import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetClubProfileScheduleRequest } from '@/shared/api/requests/club/club-schedule/get/request';
import { getClubProfileSchedule } from '@/shared/api/requests/club/club-schedule/get/request';

export const useClubProfileScheduleQuery = (
  params: GetClubProfileScheduleRequest,
  settings?: QuerySettings<typeof getClubProfileSchedule>
) =>
  useQuery({
    queryKey: ['ClubProfileSchedule', params.clubId],
    queryFn: () =>
      getClubProfileSchedule({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
